
import React from 'react';
import { Linkedin, MessagesSquare, Twitter } from 'lucide-react';

const FooterBottom = () => {
  return (
    <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
      <div className="text-sm text-brand-grey">
        © {new Date().getFullYear()} Cutshort. All rights reserved.
      </div>
      
      <div className="flex items-center space-x-6 mt-4 md:mt-0">
        <a href="https://cutshort.io/blog" target="_blank" rel="noopener noreferrer" className="text-brand-grey hover:text-brand-blue transition-colors">
          Blog
        </a>
        <div className="flex items-center space-x-4">
          <a href="https://www.linkedin.com/company/3836388" target="_blank" rel="noopener noreferrer" className="text-brand-grey hover:text-brand-blue transition-colors">
            <Linkedin size={18} />
          </a>
          <a href="https://medium.com/cutshort" target="_blank" rel="noopener noreferrer" className="text-brand-grey hover:text-brand-blue transition-colors">
            <MessagesSquare size={18} />
          </a>
          <a href="https://x.com/cutshorthq" target="_blank" rel="noopener noreferrer" className="text-brand-grey hover:text-brand-blue transition-colors">
            <Twitter size={18} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;
